/* =========================
   🧠 等待 Google Maps 加载
========================= */
function waitForGoogle(callback) {
  if (window.google && window.google.maps) {
    callback();
  } else {
    setTimeout(() => waitForGoogle(callback), 100);
  }
}

if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template")?.content?.firstElementChild?.cloneNode(
            true,
          );

        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        this.geocoder = null;

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) rootUrl += "/";

        const url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");

            this.renderPreview(html);
          })
          .catch(() => {
            const btn = this.querySelector("button");
            if (btn) btn.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        if (this.errorHtml) this.appendChild(this.errorHtml);
        this.querySelector("button")?.addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const oldDrawer = document.querySelector("pickup-availability-drawer");
        if (oldDrawer) oldDrawer.remove();

        const preview = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        );

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");

        const newDrawer = sectionInnerHTML.querySelector(
          "pickup-availability-drawer",
        );
        document.body.appendChild(newDrawer);

        const button = this.querySelector("button");

        if (button) {
          button.addEventListener("click", (evt) => {
            newDrawer.show(evt.target);

            setTimeout(() => {
              this.initPickupSearch();
              this.autoLocate(); // ✅ 自动定位（可删）
            }, 0);
          });
        }
        this.updatePickupText();
      }
      /* =========================
         🔍 搜索逻辑
      ========================= */
      initPickupSearch() {
        setTimeout(() => {
          const input = document.getElementById("pickup-search-input");
          const btn = document.getElementById("pickup-search-btn");
          const listEl = document.querySelector(".pickup-availability-list");

          if (!input || !btn || !listEl) return;

          // 防重复绑定 input
          if (!input.dataset.binded) {
            input.dataset.binded = "true";
            input.addEventListener("input", () => {
              if (!input.value.trim()) {
                listEl
                  .querySelectorAll(".search-result")
                  .forEach((el) => el.remove());
              }
            });
          }

          // 防重复绑定 button
          if (btn.dataset.binded) return;
          btn.dataset.binded = "true";

          waitForGoogle(async () => {
            if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

            btn.addEventListener("click", async () => {
              const address = input.value.trim();
              if (!address) {
                listEl
                  .querySelectorAll(".search-result")
                  .forEach((el) => el.remove());
                return;
              }

              try {
                const { lat, lng } = await this.geocodeAddress(address);
                const nearbyOutlets = await this.fetchNearbyOutlets({
                  sku: this.dataset.sku,
                  quantity: 1,
                  lat,
                  lon: lng,
                  count: 5,
                });

                // 处理 Shopify li
                const shopifyLis = Array.from(
                  listEl.querySelectorAll(
                    ".pickup-availability-list__item[data-store-name]",
                  ),
                );
                const shopifyMap = {};
                shopifyLis.forEach((li) => {
                  const name = li.dataset.storeName.trim();
                  if (!shopifyMap[name]) shopifyMap[name] = li;
                  else li.remove(); // 重复删除
                });

                const renderedNames = new Set();
                const finalHTML = [];

                nearbyOutlets.forEach((outlet) => {
                  const name = outlet.outlet_title.trim();
                  if (renderedNames.has(name)) return;
                  renderedNames.add(name);

                  if (shopifyMap[name]) {
                    // 匹配成功，放最上面
                    finalHTML.push(shopifyMap[name].outerHTML);
                    delete shopifyMap[name];
                  } else {
                    // 未匹配 Shopify 的
                    finalHTML.push(`
                      <li class="pickup-availability-list__item search-result">
                        <label class="store-item-label">
                          <input type="radio" name="pickup-store" class="select-store-input" value="${name}">
                          <div class="store-content">
                            <h3 class="h4"><span class="fake-checkbox"></span>${name}</h3>
                            <p class="pickup-availability-preview caption-large">
                              <span class="svg-wrapper">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick" viewBox="0 0 20 20">
                                <path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"></path>
                              </svg>
                            </span>
                              Pickup available, Usually ready in 3 hours
                            </p>
                            <address class="pickup-availability-address">${outlet.location}</address>
                          </div>
                        </label>
                      </li>
                    `);
                  }
                });

                // 剩余未匹配 Shopify li 放后面
                Object.values(shopifyMap).forEach((li) =>
                  finalHTML.push(li.outerHTML),
                );

                // 渲染
                listEl.innerHTML = finalHTML.join("");
              } catch (err) {
                console.error(err);
                alert("Failed to fetch nearby outlets");
              }
            });
          });
        }, 300);

        this.bindStoreRadio();
        this.restoreSelectedStore();
      }

      bindStoreRadio() {
        const listEl = document.querySelector(".pickup-availability-list");

        if (!listEl || listEl.dataset.radioBinded) return;
        listEl.dataset.radioBinded = "true";

        listEl.addEventListener("change", (e) => {
          const input = e.target.closest(".select-store-input");
          if (!input) return;

          const storeData = {
            name: input.value,
            pickuptime: input.dataset.pickuptime,
          };

          localStorage.setItem("selectedStore", JSON.stringify(storeData));
          this.updatePickupText();
          // 选择门店后关闭弹窗
          document.querySelector("pickup-availability-drawer")?.hide();
          console.log("选中门店:", storeData);
        });
      }
      restoreSelectedStore() {
        const saved = localStorage.getItem("selectedStore");
        if (!saved) return;

        const data = JSON.parse(saved);

        const inputs = document.querySelectorAll(".select-store-input");

        inputs.forEach((input) => {
          if (input.value === data.name) {
            input.checked = true;
          }
        });
      }
      /* =========================
         📍 地址转经纬度
      ========================= */
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          this.geocoder.geocode({ address }, (results, status) => {
            if (status !== "OK") {
              reject(status);
              return;
            }

            const loc = results[0].geometry.location;
            resolve({
              lat: loc.lat(),
              lng: loc.lng(),
            });
          });
        });
      }

      /* =========================
         📡 调接口
      ========================= */
      async fetchNearbyOutlets(params) {
        const { sku, quantity = 1, lat, lon, count = 5 } = params;

        try {
          const res = await fetch(
            "https://shopify-big.bigcaring.com.my/api/outlet/available",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ sku, quantity, lat, lon, count }),
            },
          );

          const data = await res.json();
          return data.avaliable || [];
        } catch (err) {
          console.error(err);
          return [];
        }
      }

      /* =========================
         📍 自动定位（可选）
      ========================= */
      async autoLocate() {
        try {
          const pos = await this.getUserLocation();
          const listEl = document.querySelector(".pickup-availability-list");
          if (!listEl) return;

          const nearbyOutlets = await this.fetchNearbyOutlets({
            sku: this.dataset.sku,
            lat: pos.latitude,
            lon: pos.longitude,
          });

          // 处理 Shopify li
          const shopifyLis = Array.from(
            listEl.querySelectorAll(
              ".pickup-availability-list__item[data-store-name]",
            ),
          );
          const shopifyMap = {};
          shopifyLis.forEach((li) => {
            const name = li.dataset.storeName.trim();
            if (!shopifyMap[name]) shopifyMap[name] = li;
            else li.remove(); // 重复删除
          });

          const renderedNames = new Set();
          const finalHTML = [];

          nearbyOutlets.forEach((outlet) => {
            const name = outlet.outlet_title.trim();
            if (renderedNames.has(name)) return;
            renderedNames.add(name);

            if (shopifyMap[name]) {
              // 匹配成功，放最上面
              finalHTML.push(shopifyMap[name].outerHTML);
              delete shopifyMap[name];
            } else {
              finalHTML.push(`
          <li class="pickup-availability-list__item search-result">
            <label class="store-item-label">
              <input type="radio" name="pickup-store" class="select-store-input" value="${name}">
              <div class="store-content">
                <h3 class="h4"><span class="fake-checkbox"></span>${name}</h3>
                <p class="pickup-availability-preview caption-large">
                  <span class="svg-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick" viewBox="0 0 20 20">
                        <path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"></path>
                      </svg>
                    </span>
                  Pickup available, Usually ready in 3 hours
                </p>
                <address class="pickup-availability-address">${outlet.location}</address>
              </div>
            </label>
          </li>
        `);
            }
          });

          // 剩余未匹配 Shopify li 放后面
          Object.values(shopifyMap).forEach((li) =>
            finalHTML.push(li.outerHTML),
          );

          listEl.innerHTML = finalHTML.join("");
        } catch (err) {
          console.warn("定位失败", err);
        }
      }

      getUserLocation() {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject();
            return;
          }

          navigator.geolocation.getCurrentPosition((pos) => {
            resolve({
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
            });
          }, reject);
        });
      }
      updatePickupText() {
        const saved = localStorage.getItem("selectedStore");

        let storeName = "";
        const el = document.querySelector(
          ".product__pickup-availabilities .caption-large",
        );
        if (saved) {
          try {
            const data = JSON.parse(saved);
            if (data.name) {
              const template = el.dataset.template;

        el.innerHTML = template.replace(
          '[[location]]',
          data.name
        );
            }
          } catch (e) {}
        }
      }
    },
  );
}

/* =========================
   Drawer
========================= */
if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button")?.addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (e) => {
          if (e.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        if (
          evt.target != this &&
          !evt.target.closest("pickup-availability-drawer")
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      }

      show() {
        this.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
      }
    },
  );
}
